import { useEffect, useRef } from 'react'
import { useIntegrationApp } from '@integration-app/react'

import { CodeParamType } from 'components/Docs/codeBlock-types'

import ExampleUIBlock from '../../Docs/ExampleUIBlock'

export function EmbedFlowInstanceEditorCodeExample() {
  return (
    <ExampleUIBlock
      customCodes={{ jsx }}
      Component={Component}
      parameters={{
        INTEGRATION_KEY: CodeParamType.IntegrationKey,
        FLOW_KEY: CodeParamType.FlowKey,
      }}
    />
  )
}

const jsx = `function FlowBuilderEmbedding() {
  const targetId = 'flow-builder-emdedding'
  const integrationApp = useIntegrationApp()
  const targetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    void integrationApp
      .flowInstance({
        flowKey: parameters.FLOW_KEY,
        integrationKey: parameters.INTEGRATION_KEY,
        autoCreate: true,
      })
      .embedEditor({
        mountTargetSelector: \`[data-container-id="$\{targetId\}"]\`,
      })
  }, [
    parameters.FLOW_KEY,
    parameters.INTEGRATION_KEY,
    integrationApp
  ])

  return (
    <div
      style={{ height: '490px' }}
      data-container-id={targetId}
      ref={targetRef}
    ></div>
  )
}
`

function Component({ parameters }) {
  const targetId = 'flow-builder-emdedding'
  const integrationApp = useIntegrationApp()
  const targetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    void integrationApp
      .flowInstance({
        flowKey: parameters.FLOW_KEY,
        integrationKey: parameters.INTEGRATION_KEY,
        autoCreate: true,
      })
      .embedEditor({
        mountTargetSelector: `[data-container-id="${targetId}"]`,
      })
  }, [parameters.FLOW_KEY, parameters.INTEGRATION_KEY, integrationApp])

  return (
    <div
      style={{ height: '490px' }}
      data-container-id={targetId}
      ref={targetRef}
    ></div>
  )
}
